module.exports = __webpack_public_path__ + "static/ND_Patientsite_homepage_slider1-0a26bcc02284c2561c260163ab936763.png";